import { Pipe, PipeTransform } from '@angular/core';

enum Colors {
  MostFavourable = '#33C7C9',
  Favourable = '#45E4E2',
  Neutral = '#889AF8',
  Average = '#FFD735',
  LessFavourable = '#FFB233',
  Unfavourable = '#FF6199',
  MostUnfavourable = '#D1517F',
  Unknown = '#9599AA',
  UnknownLight = '#E5E5EA',
  Risk = '#FF9BBE',
}

enum MicrobiomeColors {
  Neutral = '#7CB5EC',
  Bad = '#F15C80',
  Good = '#90ED7D',
}

@Pipe({ name: 'colorize' })
export class ColorizePipe implements PipeTransform {
  transform(input: string, microbiomeColors = false): string {
    // If there is no input to compare return it.
    // In analysis-link we rely on not returning color for undefined/null.
    if (!input) {
      return input;
    }
    return microbiomeColors ? MicrobiomeColors[input] : Colors[input];
  }
}
